<template>
  <v-dialog v-model="dialog" max-width="500">
    <template #activator="{ on, attrs }">
      <mf-button v-bind="attrs" color="primary" label="Adicionar Hotsite" v-on:click.native="on.click" />
    </template>
    <mf-card-container
      title="Adicionar Hotsite"
      description="Adicionar um novo hotsite deve ser usado apenas para casos em que múltiplos hotsites serão utilizados. Caso contrário, edite um dos hotsites disponíveis clicando neles."
    >
      <v-row>
        <v-col>
          <v-text-field v-model="name" label="Nome" outlined hide-details :rules="[(v) => !!v || 'Nome é obrigatório']" />
        </v-col>
      </v-row>
      <v-row class="pr-3">
        <v-spacer />
        <mf-button class="mr-3" color="primary" outlined :disabled="loading" label="Cancelar" @click="dialog = false" />
        <mf-button color="primary" :disabled="!isValid" label="Adicionar" :loading="loading" @click="addHotsite" />
      </v-row>
    </mf-card-container>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddHotsiteSlot',
  props: {
    addHotsiteFn: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    name: '',
  }),
  computed: {
    isValid() {
      return this.name.trim() !== ''
    },
  },
  methods: {
    async addHotsite() {
      this.loading = true
      try {
        await this.addHotsiteFn(this.name)
        this.dialog = false
      } catch (error) {
        console.error(error)
        this.$snackbar({
          message: 'Erro ao criar novo hotsite.',
          snackbarColor: 'error',
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
